<template>
  <article class="closing">
    <section class="closing__title">
      <h3 data-anim="title" v-html="closing.title">
        {{ closing.title }}
      </h3>
    </section>
    <section class="closing__content">
      <p
        v-for="text in closing.content"
        :key="text"
        v-html="text"
        data-anim="text"
      >
        {{ text }}
      </p>
    </section>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Closing',

  data() {
    return {
      closing: {},
    };
  },

  computed: {
    ...mapGetters(['getDataCityComponent']),
  },

  created() {
    this.closing = this.getDataCityComponent(this.$route.params.city, 'closing');
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.closing {
  position: relative;
  padding: 60px 40px;

  @include mq(sm) {
    padding: 100px;
  }

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;

  &__title {
    position: relative;
    width: 100%;

    @include mq(sm) {
      width: 30%;
    }

    h3 {
      font-weight: normal;
      font-style: italic;
    }
  }

  &__content {
    position: relative;
    width: 100%;
    padding-top: 40px;

    color: $color-gray;

    @include mq(sm) {
      width: 70%;
      padding: 0 0 0 80px;
    }

    p {
      padding-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Closing.vue